import { ICopyable } from '../controls/common/icopyable';
import { IParamsValue } from './interfaces/params-value.interface';

export class ParamsValue implements ICopyable<ParamsValue> {
    public id: number = null;
    public paramId: number = null;
    public paramName: string = null;
    public paramType: string = null;
    public groupName: string = null;
    public value: string = null;
    public paramDefaultValue: string = null;
    public isInherited: boolean = null;
    public order: number = null;

    public createCopy(): ParamsValue {
        const instance = new ParamsValue();
        instance.id = this.id;
        instance.paramId = this.paramId;
        instance.paramName = this.paramName;
        instance.paramType = this.paramType;
        instance.groupName = this.groupName;
        instance.value = this.value;
        instance.paramDefaultValue = this.paramDefaultValue;
        instance.isInherited = this.isInherited;
        instance.order = this.order;
        return instance;
    }

    public static createFormCopy(paramsValue: ParamsValue): IParamsValue {
        const instance = new ParamsValue();
        instance.id = paramsValue.id;
        instance.paramId = paramsValue.paramId;
        instance.paramName = paramsValue.paramName;
        instance.paramType = paramsValue.paramType;
        instance.groupName = paramsValue.groupName;
        instance.value = paramsValue.value;
        instance.paramDefaultValue = paramsValue.paramDefaultValue;
        instance.isInherited = paramsValue.isInherited;
        instance.order = paramsValue.order;
        return instance;
    }

    public static Map(other: IParamsValue): ParamsValue {
        const instance = new ParamsValue();
        instance.id = other.id;
        instance.paramId = other.paramId;
        instance.paramName = other.paramName;
        instance.paramType = other.paramType;
        instance.groupName = other.groupName;
        instance.value = other.value;
        instance.paramDefaultValue = other.paramDefaultValue;
        instance.isInherited = other.isInherited;
        instance.order = other.order;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.paramId = other.paramId;
        this.paramName = other.paramName;
        this.paramType = other.paramType;
        this.groupName = other.groupName;
        this.value = other.value;
        this.paramDefaultValue = other.paramDefaultValue;
        this.isInherited = other.isInherited;
        this.order = other.order;
    }
}
